module.exports = __webpack_public_path__ + "img/category-skill-game-hover.34a11118.png";